
export default function BackAndForthArrows() {
  return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="grey">
          <path d="M17 4l-1.41 1.41L18.17 8H11v2h7.17l-2.58 2.59L17 14l5-5-5-5zM7 20l1.41-1.41L5.83 16H13v-2H5.83l2.58-2.59L7 10l-5 5 5 5z"></path>
      </svg>
  );
}
